import { SerializedStyles, useTheme } from "@emotion/react";
import colorsDark from "@upsun/react-component-library/src/styles/colors-dark";
import colorsLight from "@upsun/react-component-library/src/styles/colors-light";
import { UpsunTheme } from "@upsun/react-component-library/src/themes";
import React from "react";

type TickProps = {
  css?: SerializedStyles;
};

const Tick: React.FC<TickProps> = ({ css, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M9.99999 15.1C9.69999 15.1 9.49999 15 9.29999 14.8L5.09999 10.6C4.69999 10.2 4.69999 9.60002 5.09999 9.20002C5.49999 8.80002 6.09999 8.80002 6.49999 9.20002L9.99999 12.7L17.5 5.20002C17.9 4.80002 18.5 4.80002 18.9 5.20002C19.3 5.60002 19.3 6.20002 18.9 6.60002L10.7 14.8C10.5 15 10.3 15.1 9.99999 15.1Z"
          fill={theme.name === "light" ? colorsLight.PrimaryIconDefault : colorsDark.PrimaryIconDefault}
        />
      </g>
    </svg>
  );
};

export default Tick;
